export const WriteRight = "WEB_MODULE_PILOT_CERTIFICATE_COASTAL_SEGMENTS_WRITE";
export const AdminWriteRight = "WEB_MODULE_PILOT_CERTIFICATE_COASTAL_SEGMENTS_ADMIN_WRITE";

export const Rights = [
    WriteRight,
    AdminWriteRight
]
